<div class="sandbox-drawer-wrapper">
  <div class="main-content">
    <div
      class="drawer-box"
      [ngStyle]="backgroundStyles$ | async"
      (touchstart)="onDrawingAreaTouchStart($event)"
    >
      <div class="textbook-drawer-wrapper" #drawerBox>
        <gwo-textbook-drawer
          class="textbook-drawer"
          [style.opacity]="(visibility$ | async) ? 1 : 0"
          [width]="drawerBox.offsetWidth"
          [height]="drawerBox.offsetHeight"
          [fullSize]="true"
        ></gwo-textbook-drawer>
      </div>

      <section class="text-drawer-wrapper">
        <div
          class="text-drawer-background-content-wrapper"
          [class.scroll-disabled]="drawingByPointerMove$ | async"
        ></div>
        <txtb-drawer-texts
          [currentZoom$]="currentZoom$"
          [isActive$]="textToolActive$"
          [isVisible$]="visibility$"
          [isDisabled$]="drawingByPointerMove$"
          [textColor]="color$ | async"
          (isTextToolActive)="updateTextToolActive($event)"
        ></txtb-drawer-texts>
      </section>
    </div>

    <footer class="sandbox-drawer-footer">
      <button class="back-button" (click)="back()">
        <txtb-icons type="backArrow" class="back-icon"></txtb-icons>
      </button>
    </footer>
  </div>

  <section class="toolbox">
    <ul class="drawer-toolbox">
      <li class="tool border-bottom-transparent">
        <button type="button" (click)="toggleTool(ToolName.Brush)">
          <txtb-icons
            type="pencil"
            [fill]="(tool$ | async) === ToolName.Brush ? ACTIVE_COLOR : null"
          ></txtb-icons>
        </button>
      </li>

      <li class="tool border-top-bottom-transparent">
        <txtb-drawer-eraser-tool
          (toggleEraser)="toggleTool(ToolName.Eraser)"
          (clearAll)="clearCanvas()"
          [isCanvasDirty]="isCanvasDirty$ | async"
          [disabledColor]="DISABLED_COLOR"
          [clearCanvasColor]="CLEAR_CANVAS_COLOR"
          [tool$]="tool$ubject"
          [activeColor]="ACTIVE_COLOR"
          [activeFill]="(tool$ | async) === ToolName.Eraser ? ACTIVE_COLOR : null"
        ></txtb-drawer-eraser-tool>
      </li>

      <li class="tool border-top-bottom-transparent">
        <txtb-drawer-figures-tool
          (toolName)="toggleTool($event)"
          [activeColor]="ACTIVE_COLOR"
          [disabledColor]="DISABLED_COLOR"
          [pickedTool$]="tool$"
        ></txtb-drawer-figures-tool>
      </li>

      <li class="tool border-top-bottom-transparent">
        <button type="button">
          <txtb-icons
            type="text"
            [fill]="(textToolActive$ | async) ? ACTIVE_COLOR : null"
            (click)="toggleTextTool()"
          ></txtb-icons>
        </button>
      </li>

      <li class="tool border-top-transparent">
        <button type="button" class="cog-tool">
          <txtb-drawer-settings
            [activeColor]="ACTIVE_COLOR"
            [disabledColor]="DISABLED_COLOR"
            [color$]="color$"
            [size$]="size$"
            [transparency$]="transparency$"
            (colorChange)="color($event)"
            (sizeChange)="size($event)"
            (transparencyChange)="transparency($event)"
          ></txtb-drawer-settings>
        </button>
      </li>

      <li class="tool border-transparent">
        <txtb-drawer-background-tool
          [activeColor]="ACTIVE_COLOR"
          [disabledColor]="DISABLED_COLOR"
          (backgroundStyle)="updateBackgroundStyles($event)"
        ></txtb-drawer-background-tool>
      </li>

      <li class="tool border-transparent">
        <button type="button" (click)="toggleVisibility()">
          <txtb-icons
            [type]="(visibility$ | async) === false ? 'eye' : 'eyeDisabled'"
            [fill]="(visibility$ | async) === false ? ACTIVE_COLOR : null"
          ></txtb-icons>
        </button>
      </li>
    </ul>
  </section>
</div>
